import ReactDOM from 'react-dom';
import Routes from "./routes";
import * as Sentry from "@sentry/react";
import '@/styles/reset.less';
import '@/styles/common.less';
import '@/styles/rtl.less';
import '@/utils/reset-rem';
import { message } from "antd";
import reportWebVitals from './reportWebVitals';
import { setOmega, initOmega } from './utils/omega';
import { i18nStart, i18nSetLang } from "@didi/i18n-plugin";
import { LANG, USER_NAME, } from "@/utils"
import { Integrations } from "@sentry/tracing";
Sentry.init({
    release: 'cs-ticket-system@0.1.0',
    dsn: "https://b1cbb53f4c1e4df9adac30b448f2aa12@sentry-us.didiglobal.com/31",
    integrations: [new Integrations.BrowserTracing({
        tracingOrigins: [window.location.origin]
    })],
    ignoreErrors: [
        'ResizeObserver loop limit exceeded',
        'UnhandledRejection',
    ],
    tracesSampleRate: 0.01,
});
Sentry.setUser({ username: USER_NAME });

// 设置 i18n 语言
i18nStart(require("./locales/i18n-index"), require("./locales/i18n-info"));
i18nSetLang(LANG);

// message 全局设置
message.config({
    duration: 3,
    maxCount: 3,
});

// 非微前端壳页面打开情况下，omega的处理
if (window.location.pathname === '/cs-ticket-system/') {
    initOmega()
}
declare global {
    interface Window {
        __POWERED_BY_QIANKUN__?: boolean | undefined
    }
}

const render = (props: Record<string, any>) => {
    ReactDOM.render(
        <Routes />,
        props.container ? props.container.querySelector("#ticket-root") : document.getElementById('ticket-root')
    );
}

if (!window.__POWERED_BY_QIANKUN__) {
    render({});
}
export async function bootstrap() {
    console.log("[react16] CS-ticket react app bootstraped");
}

export async function mount(props: Record<string, any>) {
    // Omega设置为顶层页面穿进来的omega实例。
    const { SuperOmega } = props;
    setOmega(SuperOmega);
    // storeTest(props);
    render(props);
}

export async function unmount(props: Record<string, any>) {
    console.log("[react16] cs-ticket-system  unmount ", props);
    const { container } = props

    ReactDOM.unmountComponentAtNode(
        container
            ? container.querySelector("#ticket-root")
            : document.querySelector("#ticket-root")
    )
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
